import { useEffect,useState } from "react";
import { Box, Grid, Typography, Divider } from "@mui/material";
import { useFormik } from "formik";
import { LoadingButton } from "@mui/lab";
import FormikControl from "../../../components/common/FormikControl";
import { useDispatch, useSelector } from "react-redux";
import { addProductCalculation, editProductCalculation, selectProductCalculationLoading } from "../../../slices/productCalculations";
import { selectBmrAllProductList, fetchProductList } from "../../../slices/onBoardUser";
import {validationSchemaForProductMaster} from "../../../../utils/formik/validationSchema";
import {initialForProductMaster} from "../../../../utils/formik/initialValues"


const ProductCalculationsForm = ({ editData = null }) => {
    const allProductList = useSelector(selectBmrAllProductList)
    const dispatch = useDispatch()
    const isLoading = useSelector(selectProductCalculationLoading)
    const [initialValues, setInitialValues]= useState(initialForProductMaster)

    useEffect(() => {
      dispatch(fetchProductList())
    },[dispatch])

    useEffect(() =>{
    setInitialValues(prev => ({...prev,...editData,  product_ids: editData?.products?.map(p => p.product_id) || []
    }));
    },[editData])

    const handleSubmit = async (values) => {
        if (editData) {
            await dispatch(editProductCalculation({ data: { ...values}, editId: editData.id }))
        } else {
            await dispatch(addProductCalculation({ ...values, active: values.active}))
        }
    }
    const formik = useFormik({
        initialValues,
        validationSchema:validationSchemaForProductMaster,
        onSubmit: handleSubmit,
        enableReinitialize: true
    })

    const formOptions = [
        {
            label: 'Product Name',
            type: 'select',
            name: 'product_ids',
            multiple: true,
            required: true,
            placeholder: "Select-",
            options: allProductList?.map(list => { return { value: list.id, label: list?.name } }),
        },
        {
            label: 'Status',
            type: 'radio',
            name: 'active',
            required: true,
            defaultValue:true,
            options: [
                { value: true, label: "Active" },
                { value: false, label: "In-Active" },
            ]
        },
        {
            label: 'Description',
            type: 'textarea',
            name: 'description',
            required: true,
            placeholder: "Enter Description",
            multiline: true,
            rows: 3
        },
    ];

    const dateCalculations = [
        {
            field: "Date Of Mfg. Start",
            reference: "Date Of Apheresis",
            name: "mfg_start_days",
            required: true,
            type:'number',
            placeholder: "Enter",
            subLable:'Days'
        },
        {
            field: "Date Of Expiry",
            reference: "Date Of Manufacturing",
            name: "expiry_days",
            type:'number',
            placeholder: "Enter",
            subLable:'Days'
        },
        {
            field: "Date Of Transduction",
            reference: "Date Of Manufacturing",
            name: "transduction_days",
            type:'number',
            placeholder: "Enter",
            subLable:'Days'
        },
        {
            field: "Expected Date Of Harvest",
            reference: "Date Of Manufacturing",
            name: "harvest_days",
            type:'number',
            placeholder: "Enter",
            subLable:'Days'
        },
        {
            field: "Expected Date Of QC Release",
            reference: "Date Of Manufacturing",
            name: "qc_release_days",
            type:'number',
            placeholder: "Enter",
            subLable:'Days'
        },
        {
            field: "Expected Date Of QA Release",
            reference: "Date Of Manufacturing",
            name: "qa_release_days",
            type:'number',
            placeholder: "Enter",
            subLable:'Days'
        },
    ];

    return (
        <Box className="w-full">
            <form onSubmit={formik.handleSubmit}>
                {/* Product Details Section */}
                    <Grid container spacing={2}>
                        {formOptions.map((props, key) => (
                            <Grid key={key} item xs={12}>
                                <FormikControl 
                                    formik={formik} 
                                    {...props}
                                    className="w-full"
                                />
                            </Grid>
                        ))}
                {/* Date Calculations Section - Matched with Image Design */}
                <Grid> <Divider className="my-2" /></Grid>
      <Grid xs={12} className="w-full pl-3">
  {dateCalculations.map((item, index) => (
    <Grid
      key={`date_calc_${index}`}
      xs={12}
      className="flex items-center w-full gap-3 mt-3"
    >
      {/* Left Label */}
      <Typography
        className="font-medium text-gray-800 bg-[#F0F1F5] px-3 py-2 rounded  min-w-[220px] text-sm"
      >
        {item.field}
      </Typography>

      {/* = */}
      <span className="font-semibold item-center">=</span>

      {/* Reference */}
      <Typography
        className="font-medium text-gray-800 bg-[#F0F1F5] px-3 py-2 rounded min-w-[220px] text-sm"
      >
        {item.reference}
      </Typography>

      {/* + */}
      <span className="font-semibold">+</span>

      {/* Input full width + suffix inside */}
      <div className="relative w-full">
        {/* Input */}
        <FormikControl
          formik={formik}
          {...item}
          className="text-sm"     /* add padding-right for suffix */
        />

        {/* Suffix: Days / Months / Enter */}
        <Typography
          className="absolute top-1/2 -translate-y-[60%] right-4 text-gray-700 text-sm"
        >
          {item.subLable}
        </Typography>
      </div>
    </Grid>
  ))}
</Grid>



                {/* Submit Button */}
                <Box className="flex justify-center mt-8 items-center w-full">
                    <LoadingButton 
                        loading={isLoading} 
                        type="submit" 
                        variant="contained" 
                        className="bg-blue-600 hover:bg-blue-700 px-5 py-3 rounded-lg text-white font-medium text-base shadow-md"
                        size="large"
                    >
                        {editData ? "Update Product" : "Add Product"}
                    </LoadingButton>
                </Box>
             </Grid>
            </form>
        </Box>
    );
}

export default ProductCalculationsForm;